import Image from 'next/image'
import { useEffect } from 'react'
import { CrownIcon } from '@repo/ui'
import { useMarblePositionLabel } from 'src/hooks/useMarblePositionLabel'
import { useClientSideTranslation } from 'src/services/i18n'
import { getTranslatedMarbleColor } from 'src/services/i18n/utils/gameTranslations'
import { useGetCurrentLanguage } from 'src/store/game'
import type { Marble } from 'src/types/domain/Marble'

type Props = Readonly<{
  position: number
  marble: Marble
}>

export function RaceBannerResultEntry({ position, marble }: Props) {
  const { t } = useClientSideTranslation(useGetCurrentLanguage())
  const positionLabel = useMarblePositionLabel(position)

  useEffect(() => {
    if (marble.image) {
      const img = new window.Image()
      img.src = marble.image
    }
  }, [marble.image])

  return (
    <div className={`entry position-${position}`} key={marble.uuid}>
      {position === 1 && (
        <div className="position-winner-crown">
          <CrownIcon />
        </div>
      )}
      <div className="marble-wrapper">
        <div className="marble_blur" />
        <div className="marble active" data-tooltip={`${marble.number} -> ${positionLabel}`}>
          {position === 1 && marble.imageAlt ? (
            <Image
              alt={marble.imageAlt}
              className="marble-image"
              draggable="false"
              fill
              priority
              sizes="60px"
              src={marble.imageAlt}
            />
          ) : (
            <Image
              alt={`Marble ${marble.number}`}
              className="marble-background-image"
              draggable="false"
              fill
              priority
              sizes="60px"
              src={marble.image ?? ''}
            />
          )}
        </div>
      </div>
      <div className="marble_label">
        <div className={`marble-name marble-${marble.color}`}>
          <span>{getTranslatedMarbleColor(marble.color, t)}</span>
        </div>
        <span className="marble-position">{positionLabel}</span>
      </div>
    </div>
  )
}
